import { Trans, useTranslation } from "react-i18next";

export default function ContactUsCard() {
  const { t } = useTranslation();
  return (
    <div className="ui-card p-4 xl:p-6">
      <div className="md:mx-14 md:my-8">
        <div className="text-black">
          <div className="place-self-center text-center pb-4">
            <svg
              className="ui-icon w-6 h-6 text-ui-blue"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-message"></use>
            </svg>
          </div>
          <div className="font-body text-center font-bold text-xl pb-9 ">
            {t("ContactUsCard-MailCenter")}
          </div>
          <p class="font-bold text-[14px]  pb-4">
            {t("AgentHelp-service-claims-title")}
          </p>
          <p className="font-bold text-[14px]">
            {t("ContactUsCard-section-1-title")}
          </p>
          <div className="grid grid-cols-3 md:gap-14 pb-8 text-sm mt-2">
            {/* for S & C */}
            <div>
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-1-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-service-claims-standard-mail-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                  }}
                />
              </div>
            </div>
            <div className="md:ml-7">
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-2-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-service-claims-overnight-delivery-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                  }}
                />
              </div>
            </div>
            <div className="md:ml-7">
              <div className="text-gray-500 font-semibold ">
                {t("AgentHelp-fax")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-service-claims--fax-address"
                  components={{
                    break1: <br />,
                  }}
                />
              </div>
            </div>
          </div>
          <p className="font-bold text-[14px] ">
            {t("ContactUsCard-section-2-title")}
          </p>
          <div className="grid grid-cols-3 md:gap-14 text-sm mt-2">
            {/* for S & C */}
            <div>
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-1-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-payments-standard-mail-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                  }}
                />
              </div>
            </div>
            <div className="md:col-span-2 md:ml-7">
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-2-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-payments-overnight-delivery-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                    break3: <br />,
                  }}
                />
              </div>
            </div>
          </div>
          <p class="font-extrabold text-[14px] pb-4 pt-14">
            {t("AgentHelp-annity-service-claims-title")}
          </p>
          <p className="font-bold text-[14px]">
            {t("ContactUsCard-section-1-title")}
          </p>
          <div className="grid grid-cols-3 md:gap-14 pb-8 text-sm mt-2">
            {/* for S & C */}
            <div>
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-1-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-annity-service-claims-standard-mail-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                  }}
                />
              </div>
            </div>
            <div className="md:ml-7">
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-2-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-annity-service-claims-overnight-delivery-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                  }}
                />
              </div>
            </div>
            <div className="md:ml-7">
              <div className="text-gray-500 font-semibold ">
                {t("AgentHelp-fax")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-annity-service-claims--fax-address"
                  components={{
                    break1: <br />,
                  }}
                />
              </div>
            </div>
          </div>
          <p className="font-bold text-[14px] pt-8">
            {t("ContactUsCard-section-2-title")}
          </p>
          <div className="grid grid-cols-3 md:gap-14 text-sm mt-2">
            {/* for S & C */}
            <div>
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-1-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-annity-payments-standard-mail-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                  }}
                />
              </div>
            </div>
            <div className="md:col-span-2 md:ml-7">
              <div className="text-gray-500 font-semibold ">
                {t("ContactUsCard-section-1-method-2-title")}
              </div>
              <div className="text-sm text-black">
                <Trans
                  i18nKey="AgentHelp-annity-payments-overnight-delivery-address"
                  components={{
                    break1: <br />,
                    break2: <br />,
                    break3: <br />,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
